import { render, staticRenderFns } from "./TrainOrderList.vue?vue&type=template&id=031fed8e&scoped=true"
import script from "./TrainOrderList.vue?vue&type=script&lang=js"
export * from "./TrainOrderList.vue?vue&type=script&lang=js"
import style0 from "./TrainOrderList.vue?vue&type=style&index=0&id=031fed8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031fed8e",
  null
  
)

export default component.exports